module.exports = __webpack_public_path__ + "static/img/产品.011bd45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/产品.jpg
// module id = 6BAz
// module chunks = 1